import React,{ Component } from "react";
import { Row, Col, Table, Button, Card, CardBody, CardHeader} from "reactstrap";
import { connect } from "react-redux";
import Proptypes from "prop-types";
import {getApiConfigs} from "../../../actions/actionDevloper";
import moment from "moment";
import { Link } from "react-router-dom";
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg"

class ViewApi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentApi: null,
            userId: null
        };
    }

    componentDidMount() {
        this.props.getApiConfigs();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.apis.length > 0) {
            let currentApi = nextProps.apis.find(api => api.api_id === this.props.match.params.id);
            this.setState({currentApi: currentApi});
        }
    }


    render() {
        const {currentApi} = this.state;
        return(
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <strong>View Api</strong>
                                {currentApi ? <Link className="pull-right" to={{ pathname: `/updateApi/${currentApi.api_id}`}}>
                                    <Button size="sm" 
                                    className = "reset-btn" 
                                    color="primary"> Edit Api </Button> </Link> : " " }
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                    <div className="profile-table">
                                            {currentApi?
                                                <Table >
                                                    <tbody>
                                                    <tr><td><h4>Api Id</h4></td><td>{currentApi.api_id ? currentApi.api_id : "-"}</td></tr>
                                                    <tr><td><h4>Name</h4></td><td>{currentApi.name ? currentApi.name : "-"}</td></tr>
                                                    <tr><td><h4>Api Key</h4></td><td>{currentApi.api_key ? currentApi.api_key : "-"}</td></tr>
                                                    <tr><td><h4>Api Key Secret</h4></td><td>{currentApi.api_key_secret ? currentApi.api_key_secret : "-"}</td></tr>
                                                    <tr><td><h4>Enabled</h4></td><td><img src={currentApi.enabled ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                    <tr><td><h4>Read Only</h4></td><td> <img src={currentApi.read_only ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                    <tr><td><h4>Created </h4></td><td>{currentApi.created ? moment.utc(currentApi.created).local().format("MM/DD/YY HH:mm") : "-"}</td></tr>
                                                    <tr><td><h4>Last Used </h4></td><td>{currentApi.last_used ? moment.utc(currentApi.last_used).local().format("MM/DD/YY HH:mm"): "-"}</td></tr>
                                                    </tbody>
                                                </Table>   :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }

}

ViewApi.propTypes = {
        apis: Proptypes.array
};

export default connect(state =>
        ({
            apis: state.develop.apis || [],
            getAPILoading: state.develop.getAPILoading || false,
        }),
    dispatch =>
        ({
            getApiConfigs: () => dispatch(getApiConfigs()),
        }))(ViewApi);